import { Box, IconButton, Typography, Pagination } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React from "react";

// Paginador personalizado mejorado
const CustomPagination = ({ count, rowsPerPage, page, setPage }) => {
    const totalPages = Math.ceil(count / rowsPerPage);

    const handlePreviousPage = () => {
        if (page > 0) {
            setPage((prevPage) => prevPage - 1);
        }
    };

    const handleNextPage = () => {
        if ((page + 1) < totalPages) {
            setPage((prevPage) => prevPage + 1);
        }
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage - 1); // Ajustar el índice de página (Pagination usa 1-based, nuestro estado usa 0-based)
    };

    const startItem = page * rowsPerPage + 1;
    const endItem = Math.min((page + 1) * rowsPerPage, count);

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={2}
            sx={{ flexWrap: 'wrap', gap: 2 }}
        >
            <Typography variant="body2">
                {startItem}-{endItem} de {count}
            </Typography>
            
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {/* Paginación numérica para navegación más fácil */}
                {totalPages > 1 && (
                    <Pagination 
                        count={totalPages} 
                        page={page + 1} // Ajustar el índice de página (Pagination usa 1-based, nuestro estado usa 0-based)
                        onChange={handlePageChange}
                        color="primary"
                        size="small"
                        showFirstButton 
                        showLastButton
                        sx={{ mx: 2 }}
                    />
                )}
                
                {/* Botones de navegación anterior/siguiente */}
                <IconButton
                    onClick={handlePreviousPage}
                    disabled={page === 0}
                    size="small"
                >
                    <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
                <IconButton
                    onClick={handleNextPage}
                    disabled={(page + 1) >= totalPages}
                    size="small"
                >
                    <ArrowForwardIosIcon fontSize="small" />
                </IconButton>
            </Box>
        </Box>
    );
};

export default CustomPagination;
